<template>
  <div
    class="list-pagination"
    :class="{
      'list-pagination--sticky': sticky,
      'list-pagination--align-left': align === 'left',
      'list-pagination--align-right': align === 'right',
    }"
  >
    <div class="list-pagination__inner">
      <span v-if="showTotal" class="list-pagination__total">共 {{ total }} 条</span>
      <el-select
        v-if="showSizeSelect"
        :value="pageSize"
        size="small"
        class="list-pagination__size-select"
        @change="onSizeChange"
      >
        <el-option
          v-for="size in pageSizes"
          :key="size"
          :label="size + '条/页'"
          :value="size"
        />
      </el-select>
      <el-pagination
        :small="small"
        :current-page="currentPage"
        :page-size="pageSize"
        :layout="paginationLayout"
        :total="total"
        @current-change="onPageChange"
      />
    </div>
  </div>
</template>

<script>
const DEFAULT_PAGE_SIZES = [10, 25, 50, 100, 500];

export default {
  name: "ListPagination",
  props: {
    total: {
      type: Number,
      default: 0,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    pageSizes: {
      type: Array,
      default() {
        return DEFAULT_PAGE_SIZES;
      },
    },
    showSizeSelect: {
      type: Boolean,
      default: true,
    },
    showTotal: {
      type: Boolean,
      default: true,
    },
    sticky: {
      type: Boolean,
      default: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
    align: {
      type: String,
      default: "right",
      validator(value) {
        return value === "left" || value === "right";
      },
    },
    /** 覆盖 el-pagination layout；不传则按 showTotal/showSizeSelect 自动组合 */
    layout: {
      type: String,
      default: "",
    },
  },
  computed: {
    paginationLayout() {
      if (this.layout) {
        return this.layout;
      }
      if (this.small && !this.showSizeSelect) {
        return "total, prev, pager, next";
      }
      return "prev, pager, next, jumper";
    },
  },
  methods: {
    onPageChange(page) {
      this.$emit("update:currentPage", page);
      this.$emit("page-change", page);
    },
    onSizeChange(size) {
      this.$emit("update:pageSize", size);
      this.$emit("update:currentPage", 1);
      this.$emit("size-change", size);
    },
  },
};
</script>

<style lang="less" scoped>
.list-pagination {
  margin-top: 12px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;

  &--sticky {
    position: sticky;
    bottom: 0;
    left: 0;
    z-index: 20;
    flex-shrink: 0;
    padding: 10px 12px 14px;
    background: #fff;
    border-top: 1px solid #ebeef5;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.04);
  }

  &--align-right .list-pagination__inner {
    justify-content: flex-end;
  }

  &--align-left .list-pagination__inner {
    justify-content: flex-start;
  }
}

.list-pagination__inner {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
  max-width: 100%;
}

.list-pagination__total {
  font-size: 13px;
  color: #606266;
  white-space: nowrap;
}

.list-pagination__size-select {
  width: 120px;
}

.list-pagination ::v-deep .el-pagination {
  flex-wrap: wrap;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ListPagination.vue